import Schema from '../Schema';

import { COUPON_TYPE } from '../../constants/shop';

const ShoppingCoupons = new Schema({
  _id: String,

  // クーポン名
  display_name: String,

  // Free Shippingクーポンか否か
  is_shipping_free: {
    type: Boolean,
    default: false
  },

  // 割引率
  percent_off: {
    type: Number,
    default: null
  },

  // 割引金額
  amount_off: {
    type: Number,
    default: null
  },

  // 割引についてのテキスト
  // ex: 5% OFF
  display_off: {
    type: String,
    default: null
  },

  // どのサービスで有効なクーポンか
  available_services: {
    type: Array,
    default: []
  },

  // どのプレミアム入会タイプで有効なクーポンか
  available_joining_premium_types: {
    type: Array,
    default: []
  },

  // どのプレミアムサービスのグレードで有効なクーポンか
  available_premium_services: {
    type: Array,
    default: []
  },

  // クーポンの種類
  type: {
    type: Number,
    enum: [COUPON_TYPE.AMOUNT_OFF, COUPON_TYPE.PERCENT_OFF]
  },

  // クーポンを利用するための最低利用金額
  minimum_use_amount: {
    type: Number,
    default: null
  },

  // クーポンが適用できるSKUの条件
  available_sku_conditions: {
    suppliers: [
      {
        type: String
      }
    ],
    labels: [
      {
        type: String
      }
    ]
  },

  // suppliers or labels に入力がある場合のCouponの使用条件
  summary: String,

  // static methods -------------

  // coupon が Premium会員用か
  // `/order/api`のみで使用
  is_premium_coupon: {
    type: Boolean,
    default: false
  },

  // 在庫あり商品のみに使えるクーポンか
  in_stock_only: {
    type: Boolean,
    default: false
  }
});

export default ShoppingCoupons;
